import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import Raiting from '../../UI/Raiting';
import AdvantagesSticker from '../../UI/AdvantagesSticker';
import Like from '../../UI/Like';
import Button from '../../UI/Button';

import { ICatalogItemProps } from './interface';
import bemClassName from '../../utils/bem';

import './index.scss';
import { declinationWord, getTypeCatalogItems } from '../../utils/catalogUtils';
import { formatedDateRange } from '../../utils/date';
import { bookingStatusTextVerified } from '../../utils/bookingStatusUtils';
import PrivateData from '../../API/PrivateData';
import Modal from '../../UI/Modal';
import RadioButtons from '../../UI/RadiouButtons';

const catalogItem = bemClassName('catalog-item');

const CatalogItem: React.FC<ICatalogItemProps> = ({ data, fav, current, currentData, loading }) => {
  const location = useLocation();

  const [advantages, setAdvantages] = useState<Array<string>>([]);

  const [dataProduct, setDataProduct] = useState<any>();

  const [openModal, setOpenModal] = useState<boolean>(false);

  const [causeCancellation, setСauseCancellation] = useState<string>();
  const [disabledCancellation, setDisabledCancellation] = useState<boolean>(false);

  const handleCauseCancellationValue = (value: string) => {
    if (value) {
      setDisabledCancellation(true);
    }
    setСauseCancellation(value);
  };

  const handleCloseModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event) {
      event.preventDefault();
    }
    setOpenModal(false);
  };

  const deletUserBookingDeals = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (dataProduct) {
      loading(true);
      PrivateData.deleteUserDeals(dataProduct.id, Number(causeCancellation)).then(() => {
        loading(false);
        setOpenModal(false);
        setDataProduct(false);
      });
    }
  };

  useEffect(() => {
    if (data && currentData) {
      let result = currentData.find(
        (item: any) => item.begindate === data.begindate && item.product.id === data.id,
      );
      if (!result) {
        result = currentData.find((item: any) => item.product.id === data.id);
      }
      if (result) {
        setDataProduct(result);
      }
    }
  }, [currentData, data]);

  useEffect(() => {}, [dataProduct]);

  useEffect(() => {
    if (data) {
      const advant: Array<string> = [];
      if (data.bonus && data.bonus !== 0 && data.bonus !== undefined) {
        advant.push(`+${data.bonus} к бонусным баллам`);
      }
      if (data.contactless === true) {
        advant.push('Бесконтактное заселение');
      }
      setAdvantages(advant);
    }
  }, [data]);

  return data && data.city && data.condition && data.condition.type !== 1 ? (
    <>
      <Link
        to={
          dataProduct
            ? `/catalog/${data.city.name}/${data.id}?begin=${dataProduct.begindate}`
            : `/catalog/${data.city.name}/${data.id}`
        }
        className={catalogItem({
          fits: data.condition && data.condition.type === 4,
          partially_fits:
            data.condition && (data.condition.type === 3 || data.condition.type === 2),
          fits_basic: data.condition && data.condition.type === 0,
          fav,
          current,
        })}>
        <Swiper
          className={catalogItem('carousel')}
          spaceBetween={0}
          slidesPerView={1}
          modules={[Pagination]}
          pagination={{ clickable: true }}
          loop>
          {data.photos &&
            data.photos['298x298'] &&
            data.photos['298x298']?.slice(0, 3)?.map((_, index) => {
              const photoCount = data.photos!['298x298']?.length || 0;
              return (
                <SwiperSlide key={index}>
                  <picture className={catalogItem('picture')}>
                    <source
                      media="(max-width: 720px)"
                      type="image/webp"
                      srcSet={`${data.photos?.['578x388'][index]} ${data.photos?.['1156x776'][index]} 2x, ${data.photos?.['1734x1164'][index]} 3x`}
                    />
                    <source
                      type="image/webp"
                      srcSet={`${data.photos?.['298x298'][index]} ${data.photos?.['596x596'][index]} 2x, ${data.photos?.['894x894'][index]} 3x`}
                    />
                    <img
                      className={catalogItem('image')}
                      src={`${data.photos?.['298x298'][index]}`}
                      srcSet={`${data.photos?.['596x596'][index]} ${data.photos?.['596x596'][index]} 2x, ${data.photos?.['894x894'][index]} 3x`}
                      alt=""
                    />
                  </picture>
                  {photoCount > 3 && index === 2 && (
                    <p className={catalogItem('last-slide-more')}>Ещё {photoCount - 3} фото</p>
                  )}
                </SwiperSlide>
              );
            })}
        </Swiper>
        <div className={catalogItem('info')}>
          <div className={catalogItem('title')}>
            {!fav && !current && (
              <p className={catalogItem('found-status')}>{data.condition.name}</p>
            )}
            {(fav || current) && data && data.city && (
              <p className={catalogItem('city-name')}>{data.city.name}</p>
            )}
            <h4 className={catalogItem('address')}>
              {data.rooms ? `${data.rooms}-к. квартира на ` : ''}
              {typeof data.address === 'string' ? data.address : data.address?.name}
            </h4>
          </div>
          <Raiting
            count={data.reviews ? data.reviews.avr : null}
            full
            reviews_count={data.reviews ? data.reviews.scores : undefined}
          />
          <div className={catalogItem('square')}>
            {data.bedcode && (
              <p className={catalogItem('description', { full_width: true })}>
                {data.bedcode} спальных мест
              </p>
            )}
            {data.area.total > 0 && (
              <p className={catalogItem('description')}>
                {data.area.total} м<sup>2</sup> общая площадь
              </p>
            )}
            {data.area.kitchen > 0 && (
              <p className={catalogItem('description')}>
                {data.area.kitchen} м<sup>2</sup> площадь кухни
              </p>
            )}
          </div>
          {advantages && advantages.length > 0 && <AdvantagesSticker data={advantages} />}
          <div className={catalogItem('other')}>
            <div className={catalogItem('icons')}>
              {dataProduct && dataProduct.stage_id === 'PREPAYMENT_INVOICE' && (
                <div className={catalogItem('alert-banner')}>
                  <span className={catalogItem('alert-banner-text')}>
                    Квартира пока не закреплена за Вами. Она достанется гостю, который первым внесёт
                    залог.
                  </span>
                </div>
              )}
            </div>
            <div className={catalogItem('price-info')}>
              {!current ? (
                <h2 className={catalogItem('price')}>
                  {data.total === 0 ? data.price : data.total} ₽
                </h2>
              ) : (
                dataProduct && <h2 className={catalogItem('price')}>{dataProduct.total} ₽</h2>
              )}
              {!current ? (
                <p className={catalogItem('price-for')}>
                  {data.duration === null
                    ? 'цена за сутки'
                    : `цена за ${data.duration} ${declinationWord(data.duration)}`}
                </p>
              ) : (
                dataProduct && (
                  <p className={catalogItem('price-for')}>
                    {dataProduct.duration === null
                      ? 'цена за сутки'
                      : `цена за ${dataProduct.duration} ${declinationWord(
                          dataProduct.duration ?? 0,
                        )}`}
                  </p>
                )
              )}
            </div>
          </div>
        </div>
        <Like
          id={data.id}
          externalClassName={catalogItem('like', {
            booking: location.pathname === '/account' && location.hash === '#current-bookings',
          })}
        />
        {location.pathname === '/account' && location.hash === '#current-bookings' && (
          <div className={catalogItem('booking')}>
            {dataProduct && (
              <div>
                {dataProduct.status && (
                  <p
                    className={catalogItem('booking-request', {
                      active:
                        dataProduct.stage_id === '13' ||
                        dataProduct.stage_id === '16' ||
                        dataProduct.stage_id === '14',
                    })}>
                    {bookingStatusTextVerified(dataProduct.stage_id)}
                  </p>
                )}
                {dataProduct.begindate && dataProduct.closedate && (
                  <h4 className={catalogItem('booking-date')}>
                    {formatedDateRange(dataProduct.begindate, dataProduct.closedate)}
                  </h4>
                )}
                {dataProduct.status && (
                  <h5 className={catalogItem('booking-status')}>
                    <span className={catalogItem('description')}>Статус: </span>
                    <p>{dataProduct.status}</p>
                  </h5>
                )}
                {dataProduct.stage_id === 'PREPAYMENT_INVOICE' && data.deposit && (
                  <h5 className={catalogItem('booking-status')}>
                    <span className={catalogItem('description')}>Залог: </span>
                    <p>{data.deposit} ₽</p>
                  </h5>
                )}
                {dataProduct.cashback && dataProduct.discount !== undefined && (
                  <h5 className={catalogItem('booking-status')}>
                    <span className={catalogItem('description')}>Кешбек: </span>
                    <p>{dataProduct.discount} ₽</p>
                  </h5>
                )}
                {dataProduct.total && (
                  <h5 className={catalogItem('booking-status')}>
                    <span className={catalogItem('description')}>Общая сумма: </span>
                    <p>
                      {!dataProduct.cashback &&
                        dataProduct.discount !== null &&
                        dataProduct.discount > 0 && (
                          <span className={catalogItem('crossline')}>
                            {dataProduct.discount + dataProduct.total}
                          </span>
                        )}
                      {dataProduct.total} ₽
                    </p>
                  </h5>
                )}
              </div>
            )}
          </div>
        )}
      </Link>
      <Modal open={openModal} handleClose={handleCloseModal}>
        <h3 className={catalogItem('modal-header')}>Выберите причину отмены брони</h3>
        {dataProduct && (
          <RadioButtons
            data={[
              { text: 'Изменились обстоятельства', value: 2 },
              { text: 'Нашел дешевле', value: 6 },
              { text: 'Отменилась командировка', value: 1 },
              { text: 'Другое', value: 11 },
            ]}
            name={`causeCancellation_${data.id}_${dataProduct.begindate}_${dataProduct.closedate}`}
            externalClassName={catalogItem('field')}
            handleExternal={handleCauseCancellationValue}
            valueExternal={causeCancellation}
          />
        )}
        <div className={catalogItem('modal-button')}>
          <Button
            text="Закрыть"
            handleExternal={(event: React.MouseEvent<HTMLButtonElement>) => handleCloseModal(event)}
            red
          />
          <Button
            text="Отменить бронирование"
            handleExternal={(event: React.MouseEvent<HTMLButtonElement>) =>
              deletUserBookingDeals(event)
            }
            disable={!disabledCancellation}
            typeButton="submit"
          />
        </div>
      </Modal>
    </>
  ) : (
    <Link to={`${location.pathname}`} className={catalogItem({ relocation: true })}>
      <div className={catalogItem('info', { relocation: true })}>
        {/* {data.relocation_apartament && (
          <>
            <div className={catalogItem('apartament', { start: true })}>
              <img
                className={catalogItem('image')}
                src={data.relocation_apartament[0].images[0]}
                alt=""
              />
              <div className={catalogItem('title')}>
                <p className={catalogItem('found-status', { relocation: true })}>
                  {data.relocation_apartament[0].date}
                </p>
                <h4 className={catalogItem('address')}>{data.relocation_apartament[0].address}</h4>
                <Raiting count={data.relocation_apartament[0].raiting} full />
              </div>
            </div>
            <div className={catalogItem('apartament')}>
              <img
                className={catalogItem('image')}
                src={data.relocation_apartament[1].images[0]}
                alt=""
              />
              <div className={catalogItem('title')}>
                <p className={catalogItem('found-status', { relocation: true })}>
                  {data.relocation_apartament[1].date}
                </p>
                <h4 className={catalogItem('address')}>{data.relocation_apartament[1].address}</h4>
                <Raiting count={data.relocation_apartament[1].raiting} full />
              </div>
            </div>
          </>
        )} */}
      </div>
      <div className={catalogItem('other')}>
        <div className={catalogItem('date')}>
          {data && data.condition && (
            <p className={catalogItem('found-status')}>
              {getTypeCatalogItems(data.condition.type)}
            </p>
          )}
          {/* <h4>{data.full_date}</h4> */}
        </div>
        <div className={catalogItem('price-info')}>
          {data && data.price && <h2 className={catalogItem('price')}>{data.price} ₽</h2>}
          {/* <p className={catalogItem("price-for")}>{data.price_for}</p> */}
        </div>
      </div>
    </Link>
  );
};

export default CatalogItem;
